import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import "./Contact.css";

function Contact() {
    const form = useRef();
    const [isSending, setIsSending] = useState(false);

    const sendEmail = (e) => {
      e.preventDefault();
      setIsSending(true);
  
      emailjs
        .sendForm('service_pq84zag', 'template_97ws4aq', form.current, {
          publicKey: 'HmanlotERFJP5BSt9',
        })
        .then(
          () => {
            alert("Email sent successfully");
            form.current.reset();
            setIsSending(false);
          },
          (error) => {
            console.log('Failed to send email...', error.text);
            setIsSending(false);
          },
        );
    }

  return (
    <section className="contact-us">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2 className="sub-title">Get In Touch</h2>
            <h2 className="main-title split-text" id="split-text" data-splitting >
              Tell us about your project —whether it's a website, SEO, or
              marketing.
            </h2>
            <div className="row mt-5 gap-3">
              <div className="col-6">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <i className="hgi hgi-stroke hgi-rounded hgi-flip-phone"></i>
                  <h2 className="sub-title">Get In Touch</h2>
                </div>
                <div className="title-descr">
                  <a href="tel:+919041614997">+91 90416 14997</a>
                  <br />
                  <a href="tel:+919779176990">+91 97791 76990</a>
                </div>
              </div>

              <div className="col-5">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <i className="hgi hgi-stroke hgi-rounded hgi-map-pinpoint-01"></i>
                  <h2 className="sub-title">Address</h2>
                </div>
                <div className="title-descr">
                  <span>Mohali (INDIA)</span>
                  <br />
                  <span>Dubai (UAE)</span>
                </div>
              </div>

              <div className="col-6">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <i className="hgi hgi-stroke hgi-rounded hgi-mail-edit-01"></i>
                  <h2 className="sub-title">Email</h2>
                </div>
                <div className="title-descr">
                  <a href="mailto:digital@thecdmofficial.com">
                    digital@thecdmofficial.com
                  </a>
                </div>
              </div>

              <div className="col-5">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <i className="hgi hgi-stroke hgi-rounded hgi-at"></i>
                  <h2 className="sub-title">Social Media</h2>
                </div>
                <div className="title-descr">
                  <ul className="social-media">
                    <li>
                      <a href="https://www.facebook.com/thecdmofficial">
                        <i className="hgi hgi-stroke hgi-rounded hgi-facebook-01"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/thecdmofficial?igsh=bHBsaWVyb3Q5ZWt1">
                        <i className="hgi hgi-stroke hgi-rounded hgi-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/cdm-official/">
                        <i className="hgi hgi-stroke hgi-rounded hgi-linkedin-01"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <form className="home-form" ref={form} onSubmit={sendEmail}>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input type="text" className="form-control" id="name" name="from_name" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email address
                    </label>
                    <input type="email" className="form-control" id="email" name="from_email" aria-describedby="emailHelp" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Phone Number
                    </label>
                    <input type="tel" className="form-control" id="phone" name="from_phone" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="whatsapp" className="form-label">
                      WhatsaApp Number
                    </label>
                    <input type="tel" className="form-control" id="whatsapp" name="from_whatsapp" />
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="business" className="form-label">
                      Business Type
                    </label>
                    <input type="text" className="form-control" id="business" name="from_business" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="location" className="form-label">
                      Location
                    </label>
                    <input type="text" className="form-control" id="location" name="from_location" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Calendar for Meeting Schedule
                    </label>
                    <input type="date" className="form-control" id="preferredDate" name="from_preferredDate" />
                  </div>
                  <button type="submit" className="button-black" disabled={isSending}>
                    {isSending ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
